import { useState, useEffect } from 'react';

import OPE from 'js/on-page-editing';

import RichText from 'components/rich-text/RichText';
import AccordionWithContentArea from 'components/accordion-with-content-area/AccordionWithContentArea';
import { IAccordionWithContentAreaList } from 'source/NFR.types';

const AccordionWithContentAreaList: React.FC<IAccordionWithContentAreaList> = ({
  content,
  description,
  htmlId,
  onPageEditing,
  richText,
  text,
  themeTags,
  title
}) => {
  const [anchorHashList, setAnchorHashList] = useState<string[]>([]);

  const addAnchorHash = (anchorHash: string): void => {
    setAnchorHashList((state = []) => [anchorHash, ...state]);
  };

  const removeAnchorHash = (anchorHash: string): void => {
    setAnchorHashList(state => state.filter(hash => hash !== anchorHash));
  };

  useEffect(() => {
    if (!anchorHashList.length) {
      return;
    }

    const hash = anchorHashList[0] || ' ';
    history.replaceState(undefined, '', hash);
  }, [anchorHashList]);

  return (
    <div className="accordion-with-content-area-list">
      <div className="accordion-with-content-area-list-header">
        {title && (
          <h2 className="accordion-with-content-area-list--title" id={htmlId} {...OPE(onPageEditing?.title)}>
            {title}
          </h2>
        )}
        {description && <p>{description}</p>}
        {themeTags && !!themeTags.length && (
          <div className="accordion-with-content-area-list--tag-list">
            {themeTags?.map((tag, index) => (
              <span className="accordion-with-content-area-list--tag-list-item" key={tag + index}>
                {tag}
              </span>
            ))}
          </div>
        )}
        {text && !themeTags && <p>{text}</p>}

        {richText && <RichText {...richText} />}
      </div>
      {content?.map((acc, i) => (
        <AccordionWithContentArea
          key={'index-acc-' + i}
          {...acc}
          onPageEditing={onPageEditing}
          addAnchorHash={addAnchorHash}
          removeAnchorHash={removeAnchorHash}
        />
      ))}
    </div>
  );
};

AccordionWithContentAreaList.displayName = 'AccordionWithContentAreaList';

export default AccordionWithContentAreaList;
